import { useState, useRef } from "react";
import axios from "axios";

export function usePaginatedFetch({ url, pageSize = 10 }) {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const didFetch = useRef(false);

  const fetchData = async (pageToFetch = 0) => {
    if (loading || !hasMore) return;

    try {
      setLoading(true);

      const res = await axios.get(`${url}?page=${pageToFetch}`);
      const { data, hasMore: more } = res.data;
      setItems(prev => [...prev, ...data]);
      setHasMore(more);
      setPage(pageToFetch);
    } catch (err) {
      console.error("Pagination fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  const initFetch = () => {
    if (didFetch.current) return;
    didFetch.current = true;
    fetchData(0);
  };

  return {
    items,
    page,
    hasMore,
    loading,
    fetchNext: () => fetchData(page + 1),
    initFetch
  };
}
